import React, { ButtonHTMLAttributes } from 'react'

/**
 * Button component properties.
 * Extends the default HTML button attributes.
 */
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    /**
     * The variant of the button, which determines its styling.
     * Options: `'primary' | 'secondary' | 'danger'`.
     */
    variant?: 'primary' | 'secondary' | 'danger'
    /**
     * Indicates whether the button is in a submitting/loading state.
     * If `true`, it may display a loading state (custom implementation needed).
     */
    isSubmitting?: boolean
}
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'danger' // Add more variants as needed
    isSubmitting?: boolean
}
/**
 * Reusable Button component with customizable variants.
 *
 * @component
 * @param {ButtonProps} props - The properties passed to the button
 * @returns {JSX.Element} A styled button element
 */
const Button: React.FC<ButtonProps> = ({ variant = 'primary', disabled, isSubmitting, children, ...rest }) => {
    return (
        <button className={`btn btn-${variant} ${rest.className || ''}`} {...rest} disabled={disabled}>
            {children}
        </button>
    )
}

export default Button
